<template lang="pug">
  .player-controller
    .player-top(v-if='name')
      button(v-if='canStartGame && canStartGame.true', @click='requestStartGame') Start game

      .current-black-card-container(v-if='currentBlackCard && Object.keys(currentBlackCard).length')
        black-card(:card='currentBlackCard', :picks='blackCardPicks')

      .send(v-if='!isCzar && hand && canSendWhiteCard')
        button(@click='playSelectedWhiteCards', :disabled='selectedWhiteCards.length !== maxSelections') Play selected

      .next-turn(v-if='isCurrentWinner')
        p.you-win You win!
        button(@click='requestNextRound') Next round

    .player-czar-view(v-if='isCzar')
      strong You're the czar!
      .opponent-cards(v-if='showOpponentCards')
        ul
          li.opponent-cards-set(
            v-for='(opponentCards, key) in currentPlayedWhiteCards',
            @click='selectRoundWinner(opponentCards, key)',
            :key='key'
            :class='{ active: selectedOpponentCards && selectedOpponentCards.player === key }'
            :style='`order: ${opponentCards[0].index}`'
          )
            white-card(v-for='(card, key) in opponentCards', :card='card', :key='key')

      .send
        button(@click='sendRoundWinner', :disabled='!selectedOpponentCards') Choose selected

    .player-hand-container(v-if='hand', :class='{disabled: !canSendWhiteCard || isCzar}')
      .hand
        ul
          li(
            v-for='card in hand',
            @click='selectWhiteCard(card)',
            :class='{active: selectedWhiteCards.includes(card)}'
          )
            white-card(:card="card")
            .white-card-selected-counter(v-if='currentBlackCard && currentBlackCard.pick > 1 && selectedWhiteCards.indexOf(card) >= 0') {{ selectedWhiteCards.indexOf(card) + 1 }}
    // p(v-if='name') player name: <strong>{{name}}</strong>

    .wins(v-if='playerWins && playerWins.length')
      p wins: {{ playerWins.length }}
      ul
        li(v-for='win in playerWins')
          black-card(:card='win.winner.blackCard', :picks='win.winner.whiteCards', :hide-pick-number='true')

    player-login-form(v-if='!name', @nameSubmitted="signInUser")
</template>

<script>
  import { db } from '@/db.js'
  import PlayerLoginForm from '@/components/PlayerLoginForm'
  import WhiteCard from '@/components/WhiteCard'
  import BlackCard from '@/components/BlackCard'

  let game = db.ref('game')

  export default {
    name: 'PlayerController',
    components: {
      BlackCard,
      WhiteCard,
      PlayerLoginForm
    },
    data() {
      return {
        autoLogin: false,

        id: null,
        player: {},
        selectedWhiteCards: [],
        selectedOpponentCards: null,
        currentBlackCard: null,
        currentCzar: null,
        enoughWhiteCardsPlayed: null,
        currentPlayedWhiteCards: null,
        canSendWhiteCard: true,
        currentRoundKey: null,
        rounds: null,
        canStartGame: null
      }
    },
    firebase: {
      currentBlackCard: game.child('board/currentBlackCard'),
      currentCzar: game.child('currentCzar'),
      enoughWhiteCardsPlayed: game.child('board/enoughWhiteCardsPlayed'),
      currentPlayedWhiteCards: game.child('board/currentPlayedWhiteCards'),
      currentRoundKey: game.child('currentRoundKey'),
      rounds: game.child('rounds'),
      canStartGame: game.child('canStartGame')
    },
    computed: {
      playerRef() {
        return game.child('players/' + this.id)
      },
      boardRef() {
        return game.child('board')
      },
      name() {
        return this.player.name
      },
      hand() {
        return this.player.hand
      },
      maxSelections() {
        return this.currentBlackCard && this.currentBlackCard.pick
      },
      readyToPlayWhiteCards() {
        return this.selectedWhiteCards.length === this.maxSelections
      },
      currentCzarID() {
        return this.currentCzar && this.currentCzar['.value']
      },
      isCzar() {
        return this.id && this.currentCzarID === this.id
      },
      showOpponentCards() {
        return this.enoughWhiteCardsPlayed['.value'] === true
      },
      playerWins() {
        return this.id &&
          this.rounds &&
          Object.values(this.rounds)
            .filter(r => r.winner && r.winner.player === this.id)
      },
      isCurrentWinner() {
        return this.rounds &&
          this.currentRoundKey &&
          this.rounds[this.currentRoundKey['.value']] &&
          this.rounds[this.currentRoundKey['.value']].winner &&
          this.rounds[this.currentRoundKey['.value']].winner.player === this.id
      },
      blackCardPicks () {
        if (this.selectedWhiteCards && this.selectedWhiteCards.length) {
          return this.selectedWhiteCards
        } else if (this.selectedOpponentCards && this.selectedOpponentCards.cards && this.selectedOpponentCards.cards.length) {
            return this.selectedOpponentCards.cards
        } else {
          return null
        }
      }
    },
    methods: {
      signInUser(name) {
        // get id and bind player object

        game
          .child('players')
          .push({ name: name })
          .then(({ key }) => {
            this.id = key
            this.$rtdbBind('player', db.ref('game')
              .child('players/' + key))
              .then(response => console.log(`player ${key} signed in as ${name}`))
            if (localStorage) {
              localStorage.setItem('key', key)
            }
          })
      },

      //
      // player actions
      //

      selectWhiteCard(card) {
        if (this.isCzar) return // czar can't play
        if (!this.canSendWhiteCard) return // already played

        if (this.selectedWhiteCards.includes(card)) { // remove card if already chosen
          this.selectedWhiteCards.splice(this.selectedWhiteCards.indexOf(card), 1)
          return
        }

        if (this.readyToPlayWhiteCards)
          this.selectedWhiteCards.shift() // remove card from selection if larger than current pick
        // console.log(`${name} selecting ${card.text}`)

        this.selectedWhiteCards.push(card)
      },

      playSelectedWhiteCards() {
        if (this.readyToPlayWhiteCards) {
          // play each card in selectedWhiteCards ...
          let i = 0
          for (const card of this.selectedWhiteCards) {
            console.log(`${name} playing ${card.text}`)
            this.boardRef.child('currentPlayedWhiteCards')
              .child(this.id)
              .child(i.toString())
              .set({
                index: card.index,
                text: card.text
              })

            // ... and remove it from hand
            this.playerRef.child('hand')
              .child(card.index)
              .remove()

            this.canSendWhiteCard = false
            i++
          }

          // then reset selectedWhiteCards
          this.selectedWhiteCards = []
        }
      },

      requestNextRound() {
        game.child('nextRoundRequested')
          .set(true)
      },

      requestStartGame () {
        game.child('newGameRequested')
          .set(true)
      },

      //
      // czar actions
      //

      selectRoundWinner(cards, player) {
        this.selectedOpponentCards = {
          cards,
          player
        }
      },

      sendRoundWinner() {
        const { cards, player } = this.selectedOpponentCards
        game
          .child('rounds')
          .child(this.currentRoundKey['.value'])
          .child('winner')
          .set({
            player: player,
            whiteCards: cards,
            blackCard: this.currentBlackCard
          })
        this.selectedOpponentCards = null
      },

    },
    watch: {
      // when round changes, unlock ability to play
      currentRoundKey(key, previous) {
        this.canSendWhiteCard = true
      }
    },
    mounted() {
      if (this.autoLogin) {
        setTimeout(() => {
          this.signInUser('auto')
        }, 2000)
      } else if (localStorage && localStorage.getItem('key')) { // if has saved key
        const key = localStorage.getItem('key')
        this.id = key
        db.ref('game')
          .child('players/' + key)
          .once('value')
          .then(val => {
            console.log(val.exists())
            if (val.exists()) {
              this.$rtdbBind('player', db.ref('game')
                .child('players/' + key))
                .then(response => console.log(`player ${key} signed in ${this.name}`))  // login
            } else {
              localStorage.removeItem('key')
            }
          })
      }
    }
  }
</script>

<style scoped lang="sass">
  @import ../assets/css/var

  .player-controller
    padding: 12rem

  .player-hand-container,
  .opponent-cards
    li
      position: relative
      border: solid 2rem transparent
      border-radius: $radius

      &.active
        border-color: $blue

  .player-hand-container
    &.disabled
      opacity: .333

  .white-card-selected-counter
    width: $margin
    height: $margin
    background-color: $blue
    border-radius: 50%
    position: absolute
    top: 12rem
    right: 12rem
    color: $white
    font-size: 10rem
    display: flex
    justify-content: center
    align-items: center

  .player-top
    position: sticky
    top: 0
    background-color: $white
    z-index: 1
    margin-bottom: 36rem
    padding: 12rem
    margin-left: -12rem
    margin-right: -12rem
    border-bottom: $border

  .player-czar-view
    padding: 12rem
    margin-left: -12rem
    margin-right: -12rem
    margin-bottom: 12rem
    border-bottom: $border

  .opponent-cards
    ul
      display: flex
      flex-direction: column

  .opponent-cards-set
    margin-bottom: 12rem

    .card
      &:not(:last-child)
        margin-bottom: 4rem

  .you-win
    margin-top: 12rem
    color: $blue
    text-align: center

  .wins
    text-align: center
    margin-top: $margin
    padding-top: $margin
    border-top: $border
    margin-left: -12rem
    margin-right: -12rem
    padding-left: 12rem
    padding-right: 12rem

    p
      margin-bottom: $margin

    li + li
      margin-top: 4rem

  .send
    button
      background-color: $blue
      color: $white

      &:disabled
        background-color: transparentize($blue, .667)
</style>
